import { render, staticRenderFns } from "./LatestDischarges.vue?vue&type=template&id=11d0057f&scoped=true&"
import script from "./LatestDischarges.vue?vue&type=script&lang=js&"
export * from "./LatestDischarges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0057f",
  null
  
)

export default component.exports